/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiCountryRegionLinksListParams } from './model/apiCountryRegionLinksListParams';
import type { PaginatedCountryRegionLinkList } from './model/paginatedCountryRegionLinkList';

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiCountryRegionLinksList = (
  params?: ApiCountryRegionLinksListParams,
  signal?: AbortSignal
) => {
  return HTTP<PaginatedCountryRegionLinkList>({
    url: `/api/v7/frontend/country-region-links/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiCountryRegionLinksListQueryKey = (params?: ApiCountryRegionLinksListParams) => {
  return [`/api/v7/frontend/country-region-links/`, ...(params ? [params] : [])] as const;
};

export const getApiCountryRegionLinksListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiCountryRegionLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryRegionLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryRegionLinksList>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiCountryRegionLinksListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountryRegionLinksList>>> = ({
    signal,
  }) => apiCountryRegionLinksList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiCountryRegionLinksList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiCountryRegionLinksListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiCountryRegionLinksList>>
>;
export type ApiCountryRegionLinksListQueryError = ErrorType<unknown>;

export function useApiCountryRegionLinksList<
  TData = Awaited<ReturnType<typeof apiCountryRegionLinksList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiCountryRegionLinksListParams,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiCountryRegionLinksList>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiCountryRegionLinksListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
